export default "__VITE_ASSET__77bd44ca__"